module.exports = __webpack_public_path__ + "img/minus.a97d15eb.svg";